import {AxiosInstance, AxiosRequestConfig} from "axios";
import {ImportVehiclesApiDto} from "./model/rest";

export default class MasterCatalogApi {

	constructor(public readonly axiosInstance: AxiosInstance) {}

	uploadMasterCatalog(file: File): Promise<ImportVehiclesApiDto> {
		const url = `/api/web/vehicles/import`;
		const config: AxiosRequestConfig = {headers: {'content-type': 'multipart/form-data'}, timeout: 300000};
		const formData = new FormData();
		formData.append('file', file);
		return this.axiosInstance.post(url, formData, config)
			.then(response => response.data);
	}

}
